var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigital(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "-8.96 -8.96 49.92 49.92",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    strokeWidth: 0.256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.96,
    y: -8.96,
    width: 49.92,
    height: 49.92,
    rx: 24.96,
    fill: "#0080ff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "digitalocean"), /*#__PURE__*/React.createElement("path", {
    d: "M5.787 25.2v-3.721h-3.72v3.721zM10.239 25.2h-4.451v4.454h4.451zM16.050 1.004c-0.009-0-0.020-0-0.030-0-8.281 0-14.996 6.706-15.009 14.984v0.001h5.796c0.022-5.082 4.147-9.193 9.232-9.193 1.203 0 2.353 0.23 3.407 0.649l-0.062-0.022c2.414 0.898 4.284 2.769 5.163 5.123l0.020 0.060c0.399 0.994 0.631 2.146 0.631 3.352 0 5.078-4.104 9.198-9.176 9.224h-0.003v-5.761h-5.777v5.777h5.761v5.796c8.293-0.019 15.008-6.746 15.008-15.042 0-1.695-0.28-3.325-0.797-4.846l0.031 0.106c-1.459-4.518-4.948-8.007-9.363-9.437l-0.103-0.029c-1.412-0.462-3.037-0.734-4.724-0.744l-0.005-0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigital);
export default __webpack_public_path__ + "static/media/digital.a8a3a3699c58e3e91a3bf4efdc5816ab.svg";
export { ForwardRef as ReactComponent };